import * as React from "react"
import { createElement, forwardRef } from "@design-system/styled-system"
import { IconProps, IconComponent } from "./types"
import { Icon } from "./Icon"

function toCamelCase(str: String) {
  return str.replace(/-(.)/g, (c: String) => c.toUpperCase()).replace(/-/g, "")
}

function renderPath(path: object, index: number) {
  const camelCasePath = Object.keys(path).reduce(
    (acc, key) => {
      acc[toCamelCase(key)] = path[key]
      return acc
    },
    {
      key: `path-${index}`,
    },
  )
  return createElement("path", camelCasePath)
}

export const createIcon = (SVG: any): IconComponent => {
  const { viewBox, path, name, g } = SVG

  const Component = forwardRef<IconProps, "svg">((props, ref) => {
    return (
      <Icon {...props} viewBox={props.viewBox || viewBox} ref={ref}>
        {g ? g.map(renderPath) : renderPath(path, 0)}
      </Icon>
    )
  })

  Component.defaultProps = {
    width: 24,
    height: 24,
  }

  Component.displayName = `${name}Icon`

  return Component
}
